import Bouncer from "formbouncerjs";
import messages from "./messages";

export default new (class Validator {
    /**
     * Validator constructor
     */
    constructor() {
        this.bouncer = null;

        this.init();
    }

    /**
     * Init validator
     */
    init() {
        const lang = document.documentElement.lang;

        let validateMessages = {};

        if (lang) {
            validateMessages = messages[lang];
        } else {
            validateMessages = messages.ro;
        }
        this.bouncer = new Bouncer("._form-validation", {
            disableSubmit: true,
            messages: validateMessages,
            customValidations: {
                alphanumeric: function (field) {
                    const rules = field.getAttribute("data-rules");
                    let result = false;

                    if (!rules || !field.value) {
                        return result;
                    }

                    const ruleList = rules.split("|");

                    ruleList.forEach((rule) => {
                        // letters of any alphabet (diacritics included), digits and the punctuation real
                        // company data uses: J12/1172/2011, "S.C. X & Y", "Bl. A2/3, ap. 5", "Sector 1: ..."
                        const regex = /^[\p{L}\p{M}0-9'\-.,:/()&\s!?]+$/u;

                        if (
                            rule === "alphanumeric" &&
                            !regex.test(field.value.trim())
                        ) {
                            result = true;
                        }
                    });

                    return result;
                },
            },
        });

        document.addEventListener("bouncerFormValid", ({ target }) => {
            target.classList.remove("_form-error");
        });

        document.addEventListener("bouncerFormInvalid", ({ target }) => {
            target.classList.add("_form-error");
        });
    }

    /**
     * @param {HTMLFormElement} form
     * @return {boolean}
     */
    isNotValid(form) {
        return form.classList.contains("_form-error");
    }

    /**
     * Get bouncer
     * @return {object}
     */
    getBouncer() {
        return this.bouncer;
    }
})();
